var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('c-menu',{ref:"uploadMenu",attrs:{"menu":_vm.uploadMenu},on:{"handle":_vm.moreButtonHandle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }